import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <CardsSection />
        <FeaturesSection />
        <UpdatesSection />
        <IndexSection />
        <FaqSection />
        <MediaSection />
        <CommentsSection />
        <TopicsSection />
        <AboutSection />
        <ContactSection />
        <AppSection />
        <CarouselSection />
      </main>
      <Footer />
    </div>
  );
}